import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { ISiteDesign } from '../shared/models';
import { IMediaBankFileReference } from '../shared/media-bank';
import { cloneDeep, isDefined } from '../shared/utils';
import { FiSiteDesignService } from '@fi-shared/fi-shared-services/fi-site-design.service';
import { FiCustomerDataService } from '../shared/fi-shared-services/fi-customer-data.service';
import { AppTextService } from '@fi-shared/app-text';

@Injectable()
export class FiSiteDesignHelperService {
    constructor(
        private fiSiteDesignService: FiSiteDesignService,
        private customerDataService: FiCustomerDataService,
        private appTextService: AppTextService,
    ) {}

    private _isBrandSettingsChanged$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

    setBrandSettingsChanged(value: boolean) {
        this._isBrandSettingsChanged$.next(value);
    }

    isBrandSettingsChanged$(): Observable<boolean> {
        return this._isBrandSettingsChanged$.asObservable();
    }

    /*cloneSiteDesign(originSiteDesign: ICustomerSettings): Promise<void> {
        const newSiteDesign: ICustomerSettings = cloneDeep(originSiteDesign);
        newSiteDesign.Id = undefined;
        newSiteDesign.IsDefault = false;
        newSiteDesign.Name = `${this.appTextService.get('copy_of')} ${originSiteDesign.Name}`;
        // we also should reset Id properties for cloned media bank file references
        this.getSiteDesignMediaBankFileReferences(newSiteDesign).forEach(mbRef => mbRef.Id = undefined);
            return this.fiSiteDesignService.saveSiteDesign(newSiteDesign);
    }*/

    getSiteDesignNewInstance(): ISiteDesign {
        // todo: get default brand,
        const defaultSiteDesign = this.customerDataService.customerData.SiteDesign;
        return {
            Id: undefined,
            BrandingColor: defaultSiteDesign.BrandingColor,
            ContrastColor: defaultSiteDesign.ContrastColor,
            WidgetColor: defaultSiteDesign.WidgetColor,
            LogoReference: undefined,
            LandscapeReference: undefined,
            IsDefault: false,
            Name: undefined,
            BusinessAreaIds: [],
        };
    }

    private getSiteDesignMediaBankFileReferences(siteDesign: ISiteDesign): IMediaBankFileReference[] {
        const result: IMediaBankFileReference[] = [];
        const checkAddReferenceFn = (mediaBankFileReference: IMediaBankFileReference) => {
            if (isDefined(mediaBankFileReference)) {
                result.push(mediaBankFileReference);
            }
        };
        checkAddReferenceFn(siteDesign.LogoReference);
        checkAddReferenceFn(siteDesign.LandscapeReference);
        return result;
    }
}
